import { render, staticRenderFns } from "./DashboardTecnico.vue?vue&type=template&id=062e4853"
import script from "./DashboardTecnico.vue?vue&type=script&lang=js"
export * from "./DashboardTecnico.vue?vue&type=script&lang=js"
import style0 from "./DashboardTecnico.vue?vue&type=style&index=0&id=062e4853&prod&lang=scss"
import style1 from "./DashboardTecnico.vue?vue&type=style&index=1&id=062e4853&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports